import {
    TGetFeeLedgerListReqDto,
    TGetFeeLedgerListResDto,
    TGetFeePayerOptionsResDto,
    TSaveFeeLedgerReqDto,
    TSaveFeeLedgerResDto,
} from "@/api/services/main/fee-ledger/dtos/fee-ledger.dto";
import { QUERY_KEYS } from "@/constants/queryKeys";
import { clientApi } from "@/utils/api";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

export const getFeeLedgerListApi = async (params: TGetFeeLedgerListReqDto): Promise<TGetFeeLedgerListResDto> => {
    const { data } = await clientApi.get<TGetFeeLedgerListResDto>("/ledger/fee-ledger", { params });
    return data;
};

export const getFeePayerOptionsApi = async (): Promise<TGetFeePayerOptionsResDto> => {
    const { data } = await clientApi.get<TGetFeePayerOptionsResDto>("/ledger/fee-ledger/payer-options");
    return data;
};

export type TExportFeeLedgerReqDto = {
    fiscalYear: number;
};

export const exportFeeLedgerApi = async (params: TExportFeeLedgerReqDto) => {
    return await clientApi.get<Blob>("/ledger/fee-ledger/export", { params, responseType: "blob" });
};

export const saveFeeLedgerApi = async (payload: TSaveFeeLedgerReqDto): Promise<TSaveFeeLedgerResDto> => {
    const { data } = await clientApi.patch<TSaveFeeLedgerResDto>("/ledger/fee-ledger", payload);
    return data;
};

export const useFeeLedgerList = (params: TGetFeeLedgerListReqDto, enabled = true) => {
    return useQuery({
        queryKey: [QUERY_KEYS.FEE.FETCH_LEDGER_LIST, params],
        queryFn: () => getFeeLedgerListApi(params),
        enabled,
    });
};

export const useFeePayerOptions = () => {
    return useQuery({
        queryKey: [QUERY_KEYS.FEE.FETCH_PAYER_OPTIONS],
        queryFn: getFeePayerOptionsApi,
    });
};

export const useSaveFeeLedger = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (payload: TSaveFeeLedgerReqDto) => saveFeeLedgerApi(payload),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.FEE.FETCH_LEDGER_LIST] });
        },
    });
};
